/* eslint-disable sonarjs/no-duplicate-string */

import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  typyZdrojuLabel: {
    id: "b2b.form-switches.typy-zdroju.label",
    defaultMessage: "Resource type"
  },
  zdrojeLabel: {
    id: "b2b.form-switches.zdroje.label",
    defaultMessage: "Resource"
  },
  produktyLabel: {
    id: "b2b.form-switches.produkty.label",
    defaultMessage: "Service specification"
  }
});

export default () => useMessages(MESSAGES);
